<template>
  <div class="ChangeFrequency">
    <p class="Tips">
      {{ $t('subscription_details.replenishment.changeFrequency.confirmText', 'Would you like to change the shipping and billing frequency?') }}
    </p>

    <div class="SelectGroup">
      <app-select
        :placeholder="$t('subscription_details.replenishment.changeFrequency.placeholder.selectFrequency', 'Select frequency')"
        v-model="selectedBillingPeriod"
        :options="billingPeriods"
        :searchable="false"
        :allow-empty="false"
        :show-labels="false"
        open-direction="bottom"
        label="billingPeriodLabel"
        track-by="productRatePlanId"
        data-name="selectBillingPeriod"
        @select="onFrequencyChanged"
      />
    </div>

    <app-button
      type="submit"
      :disabled="!selectedBillingPeriod"
      @click.prevent="onSubmitButtonClicked"
      data-name="changeReplenishmentFrequency-submitButton"
      :is-loading="changeReplenishmentFrequencyTask.isActive"
    >
      {{ $t('subscription_details.replenishment.changeFrequency.button', 'Change frequency') }} ›
    </app-button>

    <app-modal name="replenishmentChangeFrequency" width="500">
      <div class="v--modal-content">
        <h3 class="modal-title">
          {{ $t('subscription_details.replenishment.changeFrequency.confirmationModal.title', 'change frequency') }}
        </h3>

        <div class="modal-content">
          <p>
            {{ $t('subscription_details.replenishment.changeFrequency.confirmationModal.text', 'Are you sure to change your frequency?') }}
          </p>

          <div class="modal-button-warpper">
            <app-button
              type="submit"
              @click.prevent="changeReplenishmentFrequencyTask.run()"
            >
              {{ $t('subscription_details.replenishment.changeFrequency.confirmationModal.button.ok', 'Ok') }}
            </app-button>

            <app-button @click="onModalCancelled">
              {{ $t('subscription_details.replenishment.changeFrequency.confirmationModal.button.cancel', 'Cancel') }}
            </app-button>
          </div>
        </div>
      </div>
    </app-modal>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { extractErrorMessage } from '@/utilities/common'

  export default {
    name: 'replenishment-change-frequency',

    props: {
      subscriptionNumber: {
        type: String,
        required: true
      },

      subscriptionRatePlanId: {
        type: String,
        required: true
      },

      billingPeriods: {
        type: Array,
        required: true
      }
    },

    data () {
      return {
        selectedBillingPeriod: null
      }
    },

    tasks (t) {
      return {
        changeReplenishmentFrequencyTask: t(async function () {
          this.$bus.$emit('close-modal', 'replenishmentChangeFrequency')
          this.trackConversion({ name: 'interaction', description: 'change_frequency' })
          this.trackConversion({ name: 'interaction', description: 'popup:change_frequency:ok' })
          const { nextReplenishmentShippingDate } = await Vue.api.subscription.changeBillPeriod(this.subscriptionNumber, this.selectedBillingPeriod.productRatePlanId)
          this.$notify({
            type: 'success',
            title: this.$t('subscription_details.replenishment.changeFrequency.success.message') + ` ${this.$options.filters.formatLocalDate(nextReplenishmentShippingDate)}`
          })

          await this.$store.dispatch('subscription/fetchSubscriptionDetails', this.subscriptionNumber)
        }).onError(function (task) {
          this.$notify({
            type: 'error',
            title: extractErrorMessage(task.error)
          })
        }).flow('drop')
      }
    },

    methods: {
      onFrequencyChanged (val) {
        const description = `frequency:${val.billingPeriodLabel}:selected`
        this.trackConversion({ name: 'interaction', description: description })
      },

      onModalCancelled () {
        this.trackConversion({ name: 'interaction', description: 'popup:change_frequency:cancel' })
        this.$bus.$emit('close-modal', 'replenishmentChangeFrequency')
      },

      onSubmitButtonClicked () {
        this.trackConversion({ name: 'interaction', description: 'change_frequency:button:submit' })
        this.$bus.$emit('open-modal', 'replenishmentChangeFrequency')
      }
    }
  }
</script>

<style lang="scss">
  .ChangeFrequency {
    .SelectGroup {
      margin-bottom: .2rem;
    }
  }
</style>
